export var createShadows = function (colors, mode) { return ({
    light: {
        // ios shadow properties
        shadowColor: mode === "light" ? colors.gray800 : colors.black,
        shadowOpacity: mode === "light" ? 0.08 : 0.2,
        shadowOffset: { width: 0, height: 4 },
        shadowRadius: 4,
        // android shadow property
        elevation: 2,
    },
    regular: {
        // ios shadow properties
        shadowColor: mode === "light" ? colors.gray800 : colors.black,
        shadowOpacity: mode === "light" ? 0.2 : 0.3,
        shadowOffset: { width: 0, height: 4 },
        shadowRadius: 8,
        // android shadow property
        elevation: 6,
    },
    tile: {
        shadowColor: mode === "light" ? colors.gray200 : colors.gray950,
        shadowOpacity: 1,
        shadowOffset: { width: 0, height: 4 },
        shadowRadius: 0,
        // android shadow property
        elevation: 6,
    },
}); };
//# sourceMappingURL=shadows.js.map